<template>
  <component :is="tag" class="sp-row" :class="classModifiers">
    <slot />
  </component>
</template>

<script setup>
import { computed } from "vue";
const props = defineProps({
  justify: {
    type: String,
    default: "start",
    validator: (value) => ["start", "center", "end", "space-between", "space-around", "space-evenly"].includes(value),
  },
  align: {
    type: String,
    default: "start",
    validator: (value) => ["start", "center", "end", "baseline", "stretch"].includes(value),
  },
  alignContent: {
    type: String,
    default: "start",
    validator: (value) =>
      ["start", "center", "end", "space-between", "space-around", "space-evenly", "stretch"].includes(value),
  },
  tag: {
    type: String,
    default: "div",
  },
  // FIXME: under unknown circumstances, camelCase props are not reactive
  columngap: {
    type: String,
    default: "var(--sp-comp-row-column-gap, 0.5rem)",
  },
  // FIXME: under unknown circumstances, camelCase props are not reactive
  rowgap: {
    type: String,
    default: "var(--sp-comp-row-row-gap, 1rem)",
  },
  height: {
    type: String,
    default: "auto",
  },
  noGutters: {
    type: [Boolean, String],
    default: false,
  },
});

const classModifiers = computed(() => ({
  "--no-gutters": props.noGutters,
}));
</script>

<style>
:host {
  display: block;
}
</style>

<style scoped lang="scss">
.sp-row {
  --row-column-gap: v-bind(columngap);
  --column-gap-start: var(--row-column-gap);
  --column-gap-end: var(--row-column-gap);
  --row-gap: v-bind(rowgap);

  display: flex;
  flex-wrap: wrap;
  flex: 1 1 auto;
  align-items: v-bind(align);
  align-content: v-bind(alignContent);
  justify-content: v-bind(justify);
  height: v-bind(height);
  margin-left: calc(var(--row-column-gap) * -1);
  margin-right: calc(var(--row-column-gap) * -1);
  row-gap: var(--row-gap);

  &.--no-gutters {
    --row-column-gap: 0;
  }
}
</style>
